import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const attendanceApi = createApi({
  reducerPath: 'attendanceApi',
  baseQuery: rtkBaseQuery('/staff/Attendance'),
  endpoints: (builder) => ({
    getAttendanceByBlockReport: builder.query({
      query: (params) => ({
        url: 'AttendanceByBlockReport',
        params,
      }),
    }),
  }),
});

export const { useLazyGetAttendanceByBlockReportQuery } = attendanceApi;
